import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "-164 1172 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M-164 1192v-7h3.333v-4h5.556v-2h-3.333v-7h8.888v7h-3.333v2h5.556v4H-144v7h-8.889v-7h3.333v-2h-8.888v2h3.333v7zm7.778-15h4.444v-3h-4.444zm-5.556 13h4.445v-3h-4.445zm11.111 0h4.445v-3h-4.445zm0-3",
      class: "fills",
      style: {"fill":"#456332","fill-opacity":"1"}
    }, null, -1)
  ]))]))
}
export default { render: render }